import { Button, Col, Flex, Form, Image, Input, Row, Space } from 'antd'
import { useState } from 'react'
import { createApi } from 'unsplash-js'
import { requiredRule } from '../utils/rules'

const unsplash = createApi({
  accessKey: import.meta.env.VITE_UNSPLASH_ACCESS_KEY,
})

interface Props {}

const UnsplashSearch = ({}: Props) => {
  const form = Form.useFormInstance()
  const [text, setText] = useState<string>('')
  const [images, setImages] = useState<
    {
      id: string
      url: string
      blurHash: string
    }[]
  >([])

  const onClick = () => {
    unsplash.search
      .getPhotos({ query: text, page: 1, perPage: 20 })
      .then((response) => {
        setImages(
          (response.response?.results ?? []).map((raw: any) => ({
            id: raw.id,
            blurHash: raw.blur_hash,
            url: raw.urls.regular,
          }))
        )
      })
  }
  const urlWatch = Form.useWatch(['unsplash', 'url'], form)
  return (
    <Flex vertical className="w-full" gap={8}>
      <Form.Item
        name={['unsplash', 'url']}
        hidden
        style={{ display: 'none' }}
        rules={[requiredRule()]}
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>

      <Form.Item
        name={['unsplash', 'blurHash']}
        hidden
        style={{ display: 'none' }}
        rules={[requiredRule()]}
        noStyle
      >
        <Input type="hidden" />
      </Form.Item>

      <Space.Compact className="w-full">
        <Input
          className="w-full"
          onChange={(event) => setText(event.target.value)}
          value={text}
        />
        <Button onClick={onClick}>Search</Button>
      </Space.Compact>

      <Row className="w-full" gutter={[8, 8]}>
        {images.map((image) => (
          <Col key={image.id} span={8}>
            <Image
              width={'100%'}
              src={image.url}
              preview={false}
              style={{
                aspectRatio: 1,
                objectFit: 'cover',
                borderStyle: image.url == urlWatch ? 'solid' : undefined,
                borderColor: image.url == urlWatch ? '#8e978a' : undefined,
                borderWidth: image.url == urlWatch ? 5 : undefined,
              }}
              onClick={() => {
                form.setFieldValue(['unsplash', 'url'], image.url)
                form.setFieldValue(['unsplash', 'blurHash'], image.blurHash)
              }}
            />
          </Col>
        ))}
      </Row>
    </Flex>
  )
}

export { UnsplashSearch }
